<template>
  <base-button
    class="
      beforeButton
      slider-controler
      hover:text-amarillo
      opacity-90
      z-1000
      ml-4
      order-1
    "
    :class="buttonClasses"
    @click="$emit('before')"
  >
    <font-icon
      v-if="prev.icon"
      :icon="prev.circle ? 'chevron-circle-left':'chevron-left' "
      :width="prev.width"
      :filter="prev.shadow ? 'drop-shadow(0 0 5px black)' : ''"
    />
    <span v-else>
      {{ prev.text }}
    </span>
  </base-button>
  <base-button
    class="
      afterButton
      slider-controler
      hover:text-amarillo
      opacity-90
      z-1000
      mr-4
      order-3
    "
    :class="buttonClasses"
    @click="$emit('after')"
  >
    <font-icon
      v-if="next.icon"
      :icon="next.circle ? 'chevron-circle-right':'chevron-right' "
      :width="next.width"
      :filter="next.shadow ? 'drop-shadow(0 0 5px black)' : ''"
    />
    <span v-else>
      {{ next.text }}
    </span>
  </base-button>
</template>

<script>
export default {
    props: {
    prev: {
      type: Object,
      required: false,
      default: () => {
        return {
          icon: true,
          text: "",
          width: "3rem"
        }
      }
    },
    next: {
      type: Object,
      required: false,
      default: () => {
        return {
          icon: true,
          text: "",
          width: "3rem"
        }
      }
    },
    buttonClasses: {
      type: String,
      requiered: false,
      default: "hidden group-hover:inline-block",
    },
  },
  emits: [ 'after', 'before']
};
</script>

<style scoped>
  button:disabled {
    opacity: 0.5;
    cursor: unset;
  }

  .beforeButton.centrados {
    left: 0rem;
  }

  .afterButton.centrados {
    right: 0rem;
  }

  .beforeButton.movil-margin-button-4{
    left: 4rem;
  }

  .afterButton.movil-margin-button-4{
    right: 4rem;
  }

  .beforeButton.movil-margin-button-2{
    left: 2rem;
  }

  .afterButton.movil-margin-button-2{
    right: 2rem;
  }

  @media screen and (min-width: 280px) {
    .beforeButton.centrados {
      left: 2rem;
    }
  
  .afterButton.centrados {
    right: 2rem;
  }
  }

  @media screen and (min-width: 330px) {
    .beforeButton.centrados {
      left: 3rem;
    }
    
    .afterButton.centrados {
      right: 3rem;
    }
  }
  
  @media screen and (min-width: 460px) {
    .beforeButton.centrados {
      left: 7rem;
    }
    
    .afterButton.centrados {
      right: 7rem;
    }
  }
</style>